import React from 'react';
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';

import { TabEventBasicData } from './tabs/TabEventBasicData';
import { TabActivities } from './tabs/TabActivities';

/**
 * Dialog principal do evento - orquestra as 2 tabs.
 * Não gerencia estado próprio - recebe tudo via props do EventList.
 */
export function EventFormDialog({
    visible,
    onHide,
    onSave,
    event,
    onChange,
    onActivitiesChange,
    submitted,
    activeIndex,
    setActiveIndex,
    posterFile,
    onPosterChange,
    apiError,
}) {
    const footer = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={onHide} />
            <Button label="Salvar" icon="pi pi-check" onClick={onSave} />
        </>
    );

    return (
        <Dialog
            visible={visible}
            breakpoints={{ '1024px': '90vw', '640px': '100vw' }}
            style={{ width: '65vw' }}
            header={event.id ? 'Editar Evento' : 'Novo Evento'}
            modal
            className="p-fluid"
            footer={footer}
            onHide={onHide}
        >
            {apiError && (
                <Message severity="error" text={apiError} className="w-full mb-3"
                    style={{ justifyContent: 'flex-start' }} />
            )}
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header="Dados do Evento">
                    <TabEventBasicData
                        event={event}
                        onChange={onChange}
                        submitted={submitted}
                        posterFile={posterFile}
                        onPosterChange={onPosterChange}
                    />
                </TabPanel>
                <TabPanel header="Atividades">
                    <TabActivities
                        activities={event.activities || []}
                        onActivitiesChange={onActivitiesChange}
                    />
                </TabPanel>
            </TabView>
        </Dialog>
    );
}
